import { render, staticRenderFns } from "./DesktopAppConfig.vue?vue&type=template&id=c36d6d82&scoped=true"
import script from "./DesktopAppConfig.vue?vue&type=script&lang=ts"
export * from "./DesktopAppConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36d6d82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c36d6d82')) {
      api.createRecord('c36d6d82', component.options)
    } else {
      api.reload('c36d6d82', component.options)
    }
    module.hot.accept("./DesktopAppConfig.vue?vue&type=template&id=c36d6d82&scoped=true", function () {
      api.rerender('c36d6d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/DesktopAppConfig.vue"
export default component.exports